import { Icon } from "@iconify/react/dist/iconify.js";

const Pagination = ({
  page,
  count,
  pageSize = 10,
  onPageChange,
  range = 5,
}) => {
  // Validar que count y pageSize sean números válidos
  const validCount = typeof count === 'number' && !isNaN(count) ? count : 0;
  const validPageSize = typeof pageSize === 'number' && !isNaN(pageSize) ? pageSize : 10;
  
  // Calcular total de páginas automáticamente
  const totalPages = Math.ceil(validCount / validPageSize);
  
  if (totalPages <= 1) return null; // No mostrar paginación si solo hay 1 página

  const half = Math.floor(range / 2);

  const goToPage = (targetPage) => {
    if (targetPage < 1 || targetPage > totalPages) return;
    onPageChange(targetPage);
  };

  let start = Math.max(1, page - half);
  let end = Math.min(start + range - 1, totalPages);

  if (end - start + 1 < range) {
    start = Math.max(1, end - range + 1);
  }

  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <div className="d-flex gap-2 justify-content-between mt-3 align-items-center flex-wrap">
      {/* Info de resultados */}
      <div className="text-sm text-secondary-light">
        Mostrando {Math.min((page - 1) * validPageSize + 1, validCount)} - {Math.min(page * validPageSize, validCount)} de {validCount} resultados
      </div>

      {/* Controles de paginación */}
      <div className="d-flex gap-2">
        {/* previous */}
        <button
          className="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
          disabled={page === 1}
          onClick={() => goToPage(page - 1)}
        >
          <Icon icon="wordpress:previous" width="16" />
        </button>

        {/* numbers */}
        {pages.map((p) => (
          <button
            key={p}
            className={`btn btn-sm d-flex align-items-center justify-content-center ${
              p === page ? "btn-primary" : "btn-outline-secondary"
            }`}
            onClick={() => goToPage(p)}
          >
            {p}
          </button>
        ))}

        {/* next */}
        <button
          className="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
          disabled={page === totalPages}
          onClick={() => goToPage(page + 1)}
        >
          <Icon icon="wordpress:next" width="16" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
